import React, { useEffect } from "react";

import { Box, Typography } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { selectCurrentLanguage } from "@src/store/app_manager/selector";
import { useSelector } from "react-redux";

import data from "@src/data/data.json";
import { Button } from "@src/components";
import dayjs from "dayjs";

export const AnalyticsPageHeader: React.FC = () => {
  const onReloadPressed = () => {};

  const language = useSelector(selectCurrentLanguage);

  useEffect(() => {
    dayjs.locale(language);
  }, [language]);

  const analyticsConfig = data[language].Analytics;

  return (
    <Box
      paddingTop={"30px"}
      paddingBottom={"90px"}
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
    >
      <Typography fontWeight={"700"} fontSize={"32px"}>
        {analyticsConfig.Header.Title}
      </Typography>
      <Button
        onClick={onReloadPressed}
        buttonSize="m"
        variant="contained"
        startIcon={<Refresh sx={{ width: "24px", height: "24px" }} />}
        sx={{
          color: "black",
        }}
        color="neutral"
      >
        <Typography fontWeight={"600"} fontSize={"20px"}>
          {analyticsConfig.Header.ButtonLabel}
        </Typography>
      </Button>
    </Box>
  );
};